import React from 'react';
import { useIonRouter } from '@ionic/react';
import { CourseStatusHorizontal } from './CourseStatusHorizontal';
import { CourseInfo } from '@/utils/courseUtils';

interface ContinueCoursesProps {
  data: CourseInfo;
}

export const ContinueCourses: React.FC<ContinueCoursesProps> = ({ data }) => {
  const router = useIonRouter();

  const handleResume = () => {
    router.push(data.buttonRoute, 'forward');
  };

  // Default placeholder data for when there's no course
  const displayData = data.hasResume ? {
    image: data.courseImage || "https://storage.googleapis.com/rev-public/default-course-thumbnail.png",
    level: null,
    title: data.courseName || "Continue Your Learning Journey",
    instructor: {
      name: "Instructor",
      avatar: "https://api.builder.io/api/v1/image/assets/e7c2d913b4d14422810bbda8f72e0c16/b662d84e338a927c04e421106e1e1f5a3b43898c?placeholderIfAbsent=true"
    },
    progress: {
      percentage: data.progressPercent,
      label: `${Math.round(data.progressPercent)}% Completed`
    }
  } : {
    image: "https://storage.googleapis.com/rev-public/default-course-thumbnail.png",
    level: null,
    title: "Start Your Learning Journey",
    instructor: null,
    progress: null
  };

  // Check if user has 0 progress (even if hasResume is true)
  const hasZeroProgress = data.progressPercent === 0;
  const buttonText = hasZeroProgress ? "Start Your Courses" : (data.hasResume ? "Resume Learning" : "Start Learning");

  return (
    <section
      className="flex flex-col items-stretch justify-center p-2.5 max-md:max-w-full"
      data-tour="click-to-begin-card"
    >
      <CourseStatusHorizontal
        image={displayData.image}
        level={displayData.level}
        title={displayData.title}
        progress={displayData.progress}
        onResume={handleResume}
        buttonText={buttonText}
        isStartButton={hasZeroProgress}
      />
    </section>
  );
};
